import { 
	SEND_PAYMENT_SUCCESS_MAIL 
} from '@/store/actions.type';

import {getJWTFromStorage, saveJWTToStorage} from '@/api/localStorage'

import moment from 'moment'
export default {
  data () {
      return {
        ispaymentinfopresent: true
      }
  },

  computed: {
	  paymentinfo() {
        localStorage.setItem("postPaymentReportGenerate",true);
		var obj = getJWTFromStorage('paymentdata');
		var paymentinfo = JSON.parse(obj).id;
        if(paymentinfo === undefined)
			this.ispaymentinfopresent = false;
        else {
            var userEmail = this.$store.state.authentication.user.email;
            var name = this.$store.state.authentication.user.name;
            var expiryDate = paymentinfo.subscriptionDetails.expiryDate;
            var paymentSuccessObj = {};
            paymentSuccessObj.userEmail = userEmail;
            paymentSuccessObj.expiryDate = moment(String(expiryDate)).format('MMM, DD YYYY');
            paymentSuccessObj.name = name.charAt(0).toUpperCase() + name.slice(1);
            paymentSuccessObj.reqId = paymentinfo.reqId;
            paymentSuccessObj.isBrokerUser = window.location.href.indexOf('/ar') > -1 ? true:false;
            this.$store.dispatch(SEND_PAYMENT_SUCCESS_MAIL , paymentSuccessObj);
		}
        
		return paymentinfo;
      },
      userData () {
        return this.$store.state.authentication.user;
      },
  },
  methods:{
	  
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/paymentcomplete.js